import React, {useState, useEffect} from 'react';
import './CodeAccess.css';
import Swal from 'sweetalert2'
import { useParams } from 'react-router-dom';
import ContainerViewer from './ContainerViewer.jsx';
import GetReCaptchaToken from '../reCAPTCHA.js';

const CodeAccess = (props) => {
    const [depotName, setDepotName] = useState("Loading...");
    let {locationGUID} = useParams();
    let {code} = useParams();
    const [authed, setAuthed] = useState(false);
    
    useEffect(()=> {
        CheckCode();

        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch(`/manned/${locationGUID}`, requestOptions).then(res => {
            return res.json()
        }).then(res=> {
            setDepotName(res.name);
        })
    });

    async function CheckCode() {

        let token = await GetReCaptchaToken();

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({url: window.location.href, location: locationGUID, code: code, token: token})
        };

        let response = await (await fetch('/CodeAccess', requestOptions)).json();
        
        if (response.successful) {
            setAuthed(true);
        }
        else {
            Swal.fire({
                title: 'Error',
                text: response.message,
                icon: 'error',
                confirmButtonText: 'Ok'
            })
        }
    }

    return (
        <div className='CodeAccess'>
            <div className="Header w-100 bg-main">
                <img src="/assets/img/abclong.svg" alt="ABC Container Hire and Sales Logo" className='Logo'/>
            </div>
            <div className="Page-Content w-90">
                <div className="w-100 text-center">
                    <h2 className='no-block-end'>Stock Available</h2>
                    <h3 className='no-block-start color-main'>{depotName}</h3>
                </div>
            </div>
            <div className="w-90 text-center col align-center justify-center">
                {
                    authed === true ?
                    <ContainerViewer GUID={locationGUID}></ContainerViewer>
                    :
                    <div></div>
                }
            </div>
        </div>
    );
};

export default CodeAccess;